<template>
  <div class="row">
    <div class="col outer-box">
      <div class="innerBox" style="height: 100%">
        <h2 style="text-align: center; font-weight: 700">Top 10 Retail Sales By City</h2>
        <div ref="retailSalesByCity" style="height: 480px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

export default {
  data () {
    return {
      chart: null
    }
  },
  props: ['filterUrl'],
  mounted () {
    this.createChart()
  },
  watch: {
    'filterUrl' : function () {
      this.fetchData()
    }
  },
  methods: {
    fetchData () {
      var length = this.chart.data.length;
      this.$http.get('/api/h1/retail-sales/by-city?' + this.filterUrl)
      .then((resp)=>{
        var data = resp.data.data;
        this.chart.addData((data != null && data.length != 0) ? data : [{city : 'No Data', qty : 1}], length)
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    createChart () {

      /* Chart code */
      // Themes begin
      am4core.useTheme(am4themes_animated);
      // Themes end

      // Create chart instance
      this.chart = am4core.create(this.$refs.retailSalesByCity, am4charts.XYChart);
      this.chart.scrollbarX = new am4core.Scrollbar();

      // Create axes
      let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "city";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      // categoryAxis.renderer.labels.template.horizontalCenter = "right";
      // categoryAxis.renderer.labels.template.verticalCenter = "middle";
      // categoryAxis.renderer.labels.template.rotation = 270;
      categoryAxis.tooltip.disabled = true;
      categoryAxis.renderer.minHeight = 110;

      let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.minWidth = 50;
      valueAxis.min = 0;

      // Create series
      let series = this.chart.series.push(new am4charts.ColumnSeries());
      series.sequencedInterpolation = true;
      series.dataFields.valueY = "qty";
      series.dataFields.categoryX = "city";
      series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
      series.columns.template.strokeWidth = 0;

      series.tooltip.pointerOrientation = "vertical";

      series.columns.template.column.cornerRadiusTopLeft = 10;
      series.columns.template.column.cornerRadiusTopRight = 10;
      series.columns.template.column.fillOpacity = 0.8;

      // on hover, make corner radiuses bigger
      let hoverState = series.columns.template.column.states.create("hover");
      hoverState.properties.cornerRadiusTopLeft = 0;
      hoverState.properties.cornerRadiusTopRight = 0;
      hoverState.properties.fillOpacity = 1;

      series.columns.template.adapter.add("fill", (fill, target) => {
        return this.chart.colors.getIndex(target.dataItem.index);
      });

      // Cursor
      this.chart.cursor = new am4charts.XYCursor();
    }
  }
}
</script>

<style scoped>

</style>
